<template>
  <v-card width="380px">
    <v-row class="dialog-header">
      <!-- League and Teams -->
      <v-col class="match-details">
        <v-list-item style="padding: 0;">
          <v-list-item-content style="padding: 0; text-align: center;">
            <v-list-item-subtitle>
              <span class="new-price">{{ description[2] }}</span>
              <span class="original-price">{{ description[3] }}</span>
            </v-list-item-subtitle>
            <v-list-item-title class="plan-name">{{ plan.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ description[1] }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
    <v-card-text style="padding: 0 48px 20px;"
      >Experiência estatística completa e utilização ilimitada do nosso sistema
      de Inteligência Artificial, indispensável a qualquer apostador. -
      Estatísticas para jogos ao vivo e para jogos do dia consequente; -
      Timewarp: controlador do tempo de jogo ao vivo; - Tips para ocorrência de
      golo ao vivo; - Leitura completa do estado do jogo atual através de ícones
      de fácil compreensão.
    </v-card-text>
    <v-list-item style="padding: 0 24px 12px 24px;">
      <v-list-item-content style="padding-left: 8px;">
        <!--         <v-btn
          block
          depressed
          color="primary"
          height="48"
          @click="subscribePlan()"
          >Subscrever</v-btn
        > -->
        <div :id="plan.id"></div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<style scoped>
.new-price {
  font-family: Gilroy-SemiBold;
  font-size: 32px;
  color: #304351;
  margin-right: 8px;
}
.original-price {
  font-family: Gilroy-Bold;
  font-size: 16px;
  text-decoration-line: line-through;
  color: #bcc5cc;
}
.plan-name {
  font-family: Gilroy-Bold;
  font-size: 20px;
  color: #304351 !important;
}
.dialog-header {
  background: #f3f6f7;
  border-bottom: 1px solid #d8e0e6;
  margin: 0 0 16px 0 !important;
}
</style>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "SubscriptionPlanCard",
  components: {},
  props: {
    plan: {}
  },
  data: () => ({
    hidePaypal: false
  }),
  methods: {
    subscribePlan() {
      console.log("subscribePlan");
    }
  },
  mounted() {
    const planId = this.plan.id;
    console.log(planId);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const parent = this;

    this.$loadScript("https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY")
      .then(() => {
        // eslint-disable-next-line no-undef
        paypal
          .Buttons({
            style: {
              layout: "vertical"
            },
            createSubscription: function(data, actions) {
              return actions.subscription.create({
                // eslint-disable-next-line @typescript-eslint/camelcase
                plan_id: planId
              });
            },
            onApprove: function(data, actions) {
              const params = {
                subscriptionId: data.subscriptionID,
                planId: parent.plan.id
              };
              parent.$emit("addSubscriptionPlan", params);
            }
          })
          .render("#" + planId);
      })
      .catch(() => {
        // Failed to fetch script
        console.log("error");
      });

    //console.log("Mounted");
  },
  computed: {
    description() {
      return this.plan.description.split("#");
    }
  }
});
</script>
